var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScore5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 8,
    viewBox: "0 0 292 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 46,
    height: 8,
    fill: "#D90D16"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 50,
    width: 46,
    height: 8,
    fill: "#E48A37"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 100,
    width: 46,
    height: 8,
    fill: "#F5BD00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 150,
    width: 46,
    height: 8,
    fill: "#80BD00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    width: 92,
    height: 8,
    fill: "#067F22"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScore5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/Score5.36e20d69.svg";
export { ForwardRef as ReactComponent };